"use client";
import { jsxs as h, jsx as l } from "react/jsx-runtime";
const c = ({
  title: a,
  titleId: i,
  desc: d,
  descId: e,
  ...r
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ag",
    viewBox: "0 0 640 480",
    "aria-labelledby": i,
    "aria-describedby": e,
    ...r,
    children: [
      d ? /* @__PURE__ */ l("desc", { id: e, children: d }) : null,
      a ? /* @__PURE__ */ l("title", { id: i, children: a }) : null,
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "ag-a", children: /* @__PURE__ */ l("path", { fillOpacity: 0.7, d: "M-79.7 0H603v512H-79.7z" }) }) }),
      /* @__PURE__ */ h(
        "g",
        {
          fillRule: "evenodd",
          clipPath: "url(#ag-a)",
          transform: "translate(74.7)scale(.9375)",
          children: [
            /* @__PURE__ */ l("path", { fill: "#fff", d: "M-79.7 0H603v512H-79.7z" }),
            /* @__PURE__ */ l("path", { fill: "#000001", d: "M-79.6 0H603v204.8H-79.7z" }),
            /* @__PURE__ */ l("path", { fill: "#0072c6", d: "M21.3 203.2h480v112h-480z" }),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#ce1126",
                d: "M603 .1V512H261.6L603 0zM-79.7.1V512h341.3L-79.7 0z"
              }
            ),
            /* @__PURE__ */ l(
              "path",
              {
                fill: "#fcd116",
                d: "M440.4 203.3 364 184l64.9-49-79.7 11.4 41-69.5-70.7 41L332.3 37l-47.9 63.8-19.3-74-21.7 76.3-47.8-65 13.7 83.2L138.5 78l41 69.5-77.4-12.5 63.8 47.8L86 203.3z"
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  c as default
};
